import type { FC } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%",
      },
      body: {
        height: "100%",
        width: "100%",
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
      ".MuiDrawer-paper": {
        borderRight: "none",
      },
      ".MuiButton-root": {
        fontSize: "0.85rem",
        borderRadius: "10px",
        padding: "6px 10px",
      },
      ".MuiCheckbox-root.Mui-checked": {
        color:
          theme.palette?.mode === "dark"
            ? theme.palette?.secondary.main
            : theme.palette?.primary.main,
        "&:hover": {
          backgroundColor:
            theme.palette?.mode === "dark"
              ? "rgba(245, 0, 87, 0.04)"
              : "rgba(80, 180, 236, 0.04)",
        },
      },
    },
  })
);

const GlobalStyles: FC = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
